export const removeSpecialsFromPhone = (str) => {
  if (!str) {
    return '';
  }

  return str.replace(/[-)( ]/g, '');
};
